export const Logo = ({ fill }: React.SVGProps<SVGPathElement>) => (
  <>
    <path
      d="M172.090361,79 C174.249595,79 176,80.7729524 176,82.96 L176,82.96 L176,174.04 C176,176.227047 174.249595,178 172.090361,178 L172.090361,178 L80.9096386,178 C78.7504048,178 77,176.227047 77,174.04 L77,174.04 L77,82.96 C77,80.7729524 78.7504048,79 80.9096386,79 L80.9096386,79 L172.090361,79 Z M126.49978,106.5 L98.99978,150.5 L153.99978,150.5 L126.49978,106.5 Z"
      fill={fill}
      fillRule="nonzero"
    />
  </>
);
